export default {
    methods: {
        tbl_td_class_w_name(class_name, row_ind) {
            if (row_ind % 2 == 1)
                return class_name + " br_rd_odd";
            return class_name;
        },
        
        tbl_td_class(rc, ind, row_ind) {
            let add_class = "";
        
            if (row_ind % 2 == 1) {
                add_class = " br_rd_odd";
            }
        
            if (ind === rc.num_rows - 1) {
                return "rc_td_bottom" + add_class;
            }
        
            return "rc_td_no_borders" + add_class;
        },
    }
}
